import DOJLogo from "../assets/doj_logo.png";

// NAVBAR LOGO
export default function NavbarLogo({ imageWidth }: NavbarLogoProps) {
    return (
        <img
            style={{ width: imageWidth }}
            src={DOJLogo}
            alt="logo"
            draggable="false"
            loading="lazy"
        />
    )
}
